import React, {useEffect, useState} from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@material-ui/core';
import {useGoVehisService} from "../../utils/axios";

const AkolDealerSpecialOfferTextDialog = ({isOpen = false, onClose, dealerNip = null, initialText = '', onSave}) => {
  const goVehisService = useGoVehisService();
  const [specialOfferText, setSpecialOfferText] = useState('');

  useEffect(() => {
    if (isOpen) {
      setSpecialOfferText(initialText || '');
    } else {
      setSpecialOfferText('');
    }
  }, [isOpen, initialText]);

  const handleSaveText = async () => {
    try {
      await goVehisService.post(`/admin/akol/dealers/${dealerNip}/specialOfferText`, specialOfferText, {
        headers: {
          "Content-Type": "text/plain; charset=utf-8",
        }
      });
      
      if (onSave) {
        onSave();
      }
      onClose();
    } catch (error) {
      console.error('Error saving special offer text:', error);
    }
  };

  const handleClose = () => {
    setSpecialOfferText('');
    onClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="special-offer-text-dialog-title" open={isOpen}>
      <DialogTitle id="special-offer-text-dialog-title">
        Tekst oferty specjalnej
      </DialogTitle>
      <DialogContent dividers style={{minWidth: '400px'}}>
        <TextField
          fullWidth
          multiline
          rows={6}
          variant="outlined"
          placeholder="Wprowadź tekst oferty specjalnej..."
          value={specialOfferText}
          onChange={(e) => setSpecialOfferText(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Anuluj
        </Button>
        <Button onClick={handleSaveText} color="primary" variant="contained">
          Zapisz
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AkolDealerSpecialOfferTextDialog;
